/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/DropdownList';
import * as _ from 'underscore';
import CategoryItem from 'app/components/DropDownItems/CategoryItem.jsx';

class CategoryPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            category: {}
        };

        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.setCategory = this.setCategory.bind(this);

    }

    componentDidMount() {

        this.props.getCategories();

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.categories.length && _.isEmpty(this.state.categories)) {
            let categories = _.clone(this.props.categories);

            categories.unshift({
                'id': 0,
                'name': 'None',
                'color': '#888888'
            });

            this.setState({
                categories
            });
        }

    }

    onCategoryChange(category, e) {

        let dataEvent = {
                currentTarget: {
                    dataset: {
                        field: 'posts[0].params.tagID'
                    }
                },
                target: {
                    value: category.id
                }
            };

        this.props.requestChange(dataEvent);

        this.setState({
            category
        });

    }

    setCategory(e) {

        let accessoryEvent = {
            currentTarget: {
                dataset: {
                    accessory: 'category'
                }
            }
        },
        dataEvent = {
            currentTarget: {
                dataset: {
                    field: 'posts[0].params.tagID'
                }
            },
            target: {
                value: this.state.category.id
            }
        };

        e.preventDefault();

        this.props.requestChange(dataEvent);
        this.props.activateAccessory(accessoryEvent);

    }

    render() {
        let tagID = null,
            tag = null,
            constants = this.props.app.config.constants,
            post = this.props.posts[0];

        // TODO: if we want to allow per post category, change 0 to this.props.activePost

        if (post.params.tagID !== undefined && (parseInt(post.params.tagID, 10) !== 0)) {
            tagID = post.params.tagID;
        }

        if (tagID) {
            tag = this.state.categories.find(({id}) => { return id === tagID; });
        }

        return (
            <div className="panel-content">
                <div className="panel-header">
                    Select a Category
                </div>
                <div className="panel-section">
                    <DropdownList
                        data={this.state.categories}
                        dataKey='id'
                        filter={false}
                        renderListItem={({ item }) => {
                            return (
                                <CategoryItem
                                    item={item}/>
                            );
                        }}
                        renderValue={({ item }) => {
                            return (
                                <CategoryItem
                                    item={item}/>
                            );
                        }}
                        placeholder="Choose Category"
                        className="category-drop"
                        defaultValue={tag}
                        onChange={this.onCategoryChange} />
                </div>
            </div>
        );
    }
}

CategoryPanel.displayName = "CategoryPanel";

export default CategoryPanel;
